import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { tokenNotExpired } from 'angular2-jwt';
import { Cookie } from 'ng2-cookies/ng2-cookies';

// Avoid name not found warnings
declare var Auth0: any;

@Injectable()
export class AuthService {
  // Configure Auth0
  redirectUrl: string = '';
  auth0 = new Auth0({
    domain: 'rockalltech.auth0.com',
    clientID: '9oCqpcavKKmmfTV0nDUHSdNMCao9v9cr',
    responseType: 'token',
    callbackURL: window.location.protocol + '//' + window.location.host
  });
  private loggedIn = false;

  constructor(private router: Router) {
    var result = this.auth0.parseHash(window.location.hash);
    if (result && result.idToken) {
      Cookie.set('id_token', result.idToken);
      Cookie.set('current_user', result.idTokenPayload.username);
      // this.router.navigate([result.state]);
      // Ignored for now due to S3 loading
    } else if (result && result.error) {
      // Need to handle this
    }
  }

  public login(username, password, callback) {
    this.auth0.login({
      connection: 'Username-Password-Authentication',
      responseType: 'token',
      username: username,
      password: password,
      state: this.redirectUrl,
      scope: 'openid username'
    }, function (err) {
      if (err) { return callback(err); }
    });
  };

  public isLoggedIn() {
    if (tokenNotExpired(null, Cookie.get('id_token'))) {
      return true;
    }
    this.logout();
    return false;
  };

  public logout() {
    Cookie.deleteAll();
  };

}


/** WEBPACK FOOTER **
 ** ./~/angular2-router-loader/src!./~/angular2-template-loader!./src/app/auth/auth.service.ts
 **/